// extracted by mini-css-extract-plugin
export default {"pageheader":"FAQ_pageheader__yYFJp","selectorRow":"FAQ_selectorRow__5pxC-","selectorButton":"FAQ_selectorButton__BHEWD"};